import { createFileRoute } from "@tanstack/react-router";

import { GeofenceAlarmPeriod } from "/src/routes/settings/General";

export const Route = createFileRoute("/_main/settings/geofence")({
  component: GeofenceAlarmPeriod,
});
